import React from "react";
import Widget from "../../../../shared/components/features/widget/Widget";
import { useSelector } from "react-redux";
import pathRouts from "../../../../shared/enums/pathRoute";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import bgtWidget from "../../../../assests/bgt/bgtWidget.png"
import classes from "./BgtWidget.module.css";

const BgtWidget = () => {

    const { texts } = useSelector(state => state.translate);

    return (
        <Widget
            color="#19086F"
            titleColor="#FFF"
            mainLink={`/${pathRouts.BGT}`}
            title={texts.bgt}
            icon={iconsList.bgt}
            className={classes.BgtWidget}
        >
            <div className={classes.BgtContent}>
                <img
                    src={bgtWidget}
                    alt={texts.bgt}
                    className={classes.BgtImg}
                />
            </div>
        </Widget>
    );
};

export default BgtWidget;